import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 0,
  height: 0,
  x: 0,
  y: 0,
  list: [
    {
      id: "1",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "2",
      type: "Container",
      name: "backgrounds",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "3",
      type: "Container",
      name: "nodesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "4",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "5",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world16_1",
      parent: "2",
      data: ""
    },
    {
      id: "7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1350,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world16_2",
      parent: "2",
      data: ""
    },
    {
      id: "8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2700,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world16_3",
      parent: "2",
      data: ""
    },
    {
      id: "9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4050,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world16_4",
      parent: "2",
      data: ""
    },
    {
      id: "10",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5400,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world16_5",
      parent: "2",
      data: ""
    },
    {
      id: "11",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6750,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world16_6",
      parent: "2",
      data: ""
    },
    {
      id: "12",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8100,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world16_7",
      parent: "2",
      data: ""
    },
    {
      id: "13",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9450,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world16_8",
      parent: "2",
      data: ""
    },
    {
      id: "14",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 314,
      y: 553,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "15",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 414,
      y: 534,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "16",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 513,
      y: 511,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "17",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 578,
      y: 439,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "18",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 617,
      y: 355,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "19",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 680,
      y: 278,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "20",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 781,
      y: 250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "21",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 875,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "22",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 922,
      y: 373,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "23",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 958,
      y: 455,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "24",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1021,
      y: 523,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "25",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1118,
      y: 557,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "26",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1223,
      y: 539,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "27",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1301,
      y: 478,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "28",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1379,
      y: 418,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "29",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1475,
      y: 390,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "30",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1571,
      y: 418,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "31",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1664,
      y: 451,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "32",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1768,
      y: 459,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "33",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1863,
      y: 422,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "34",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1937,
      y: 357,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "35",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2011,
      y: 301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "36",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2118,
      y: 305,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "37",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2181,
      y: 373,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "38",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2242,
      y: 443,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "39",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2312,
      y: 506,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "40",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2411,
      y: 526,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "41",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2502,
      y: 476,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "42",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2577,
      y: 412,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "43",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2649,
      y: 348,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "44",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2740,
      y: 302,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "45",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2847,
      y: 309,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "46",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2923,
      y: 366,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "47",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3019,
      y: 396,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "48",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3118,
      y: 384,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "49",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3209,
      y: 347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "50",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3313,
      y: 351,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "51",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3376,
      y: 416,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "52",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3455,
      y: 472,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "53",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3544,
      y: 519,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "54",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3645,
      y: 535,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3738,
      y: 499,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "56",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3818,
      y: 447,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "57",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3898,
      y: 393,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "58",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3982,
      y: 346,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "59",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4078,
      y: 316,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "60",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4180,
      y: 303,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "61",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4280,
      y: 306,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "62",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4377,
      y: 323,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "63",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4470,
      y: 352,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "64",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4564,
      y: 383,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "65",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4658,
      y: 419,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "66",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4757,
      y: 434,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "67",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4845,
      y: 390,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "68",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4923,
      y: 338,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "69",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5000,
      y: 282,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "70",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5093,
      y: 246,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "71",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5190,
      y: 266,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "72",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5273,
      y: 311,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "73",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5342,
      y: 372,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "234",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5419,
      y: 426,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "235",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5514,
      y: 455,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "236",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5612,
      y: 436,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "237",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5697,
      y: 389,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "238",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5784,
      y: 348,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "239",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5886,
      y: 337,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "240",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5987,
      y: 341,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "241",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6081,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "242",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6169,
      y: 403,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "243",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6252,
      y: 453,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "244",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6341,
      y: 494,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "245",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6430,
      y: 533,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "246",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6530,
      y: 545,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "247",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6616,
      y: 504,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "248",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6698,
      y: 453,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "97019756-7044-4ef4-926a-1e220d8a2e92",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6779,
      y: 399,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "833c1383-c717-428a-a05b-eb56917927b4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6863,
      y: 355,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4044abf6-409c-48db-9797-f479ed291306",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6959,
      y: 330,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "26289178-2442-4845-a4e5-9241f263305c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7061,
      y: 319,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "7fda5587-e783-41cd-bf4c-4c105e1cb964",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7162,
      y: 317,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "1a17231e-7981-4bfd-98f8-d387f385dfaf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7259,
      y: 343,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "5258fd34-0dfe-44b1-98a2-89866bcccc55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7352,
      y: 376,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "7d858b90-e6f0-48ca-bea7-7e58962b99e9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7436,
      y: 422,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d2d6423e-7702-4019-af3b-ebfe57476858",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7526,
      y: 463,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b9d93c21-ad35-4193-ba1d-474d8206fc9b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7620,
      y: 489,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "239b6216-6220-49fa-b1fa-407e32cc2b3f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7719,
      y: 500,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "0b50c6c2-06b4-49cb-b444-0bf93e866ccf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7819,
      y: 488,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "a853293d-5188-4175-81e9-2fc185d69991",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7906,
      y: 441,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "48f7e46e-6dcc-4bb9-b23e-70ebd58e31cf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7971,
      y: 375,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "04c7d583-92a7-4e72-abc2-8a78a7f9309c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8045,
      y: 308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d2479994-6e94-4fdb-9258-a55a60cda46d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8132,
      y: 259,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "be575f5f-03b6-47d9-a60c-75c7a90177b9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8241,
      y: 261,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "214f2d2a-cb9d-488a-b484-6169db766b97",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8327,
      y: 309,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "f2a0ce9c-9c21-4b23-932b-66ac26913563",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8387,
      y: 383,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "c7e5bd0c-178f-4d34-8755-7a4ae3fa0185",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8449,
      y: 454,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4e23a73b-740d-4d7c-bc11-87068e9a1e2f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8518,
      y: 521,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "c3da5535-4140-4f95-a9c6-8532a609bf90",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8614,
      y: 552,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "804caaed-fb76-4b02-853b-edcf6475278c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8716,
      y: 531,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "bc6d4ad3-5f43-489a-922b-4848c5927f1a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8792,
      y: 465,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "2747316e-b531-42b1-aaaf-0613247a5a7c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8863,
      y: 397,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "10149a39-9b13-4218-a36b-b4b399f28bbf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8960,
      y: 360,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "2a4d9421-7bdd-421c-983f-76bb551e7cca",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9051,
      y: 403,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "50f9ec12-d3d7-48a9-b0e7-b775ade9f832",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9151,
      y: 430,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b081e3dd-32b6-464d-aa73-d906500256a3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9238,
      y: 383,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "af006587-561a-4cfd-8b28-75cb6a904d38",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9320,
      y: 327,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "09770187-c0eb-4df1-8a96-27fa3be818b3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9423,
      y: 319,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "6b5012a3-4b0a-4b6c-8e0a-bc1ea46ce4c8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9511,
      y: 363,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "042e84c8-f9c6-4f9b-a7cd-dede5005320b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9586,
      y: 420,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d4e69009-f330-4a07-a8e6-07b3f6ee9ab5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9659,
      y: 478,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4bf018d6-cefb-4d15-aa13-dcb343144954",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9735,
      y: 534,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "f9778ec5-1269-4837-bf05-7c300f54a124",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9829,
      y: 561,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "9ef9602b-b619-4460-b964-73580514c8da",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9929,
      y: 540,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "50062a02-a664-4542-b494-3fd64c6e6d55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10005,
      y: 481,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "236ff5dd-21bb-42a4-94e4-d49e8b593521",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10067,
      y: 412,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "56fb5f58-a58e-4d99-b736-487f3408d496",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10139,
      y: 351,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "58f5ce4b-4532-4eb7-8afb-0f717915a7a9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10240,
      y: 343,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b1aa866f-8bf6-4cec-aa8d-cc96c0950767",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10317,
      y: 397,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "cfe66084-999d-4529-9bca-2e03e14a4a6e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10390,
      y: 457,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "043f9df6-85ed-440d-b748-b4250f63c2de",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10475,
      y: 501,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "1930b574-8714-4055-84eb-0fd33d2cf2fc",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10576,
      y: 501,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "74",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "110",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "164",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "185",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "214",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "219",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "224",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "229",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "106",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "160",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "181",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "210",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "215",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "220",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "225",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "230",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "75",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1131,
      y: 75,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "76",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1263,
      y: 64,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "77",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1387,
      y: 37,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "78",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1484,
      y: 106,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "79",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1588,
      y: 68,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "80",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1084,
      y: 134,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "81",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1229,
      y: 125,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "82",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1376,
      y: 136,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "83",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1576,
      y: 165,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "84",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1049,
      y: 219,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "85",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1201,
      y: 219,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "86",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1311,
      y: 182,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "87",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1474,
      y: 202,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "88",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1560,
      y: 263,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "89",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1060,
      y: 326,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "90",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1147,
      y: 289,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "91",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1321,
      y: 301,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "92",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1408,
      y: 260,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "93",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1236,
      y: 344,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "94",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1163,
      y: 399,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "95",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 769,
      y: 497,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "96",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 669,
      y: 578,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "97",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 800,
      y: 589,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "98",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 899,
      y: 624,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "99",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 570,
      y: 655,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "100",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 705,
      y: 661,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "101",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 797,
      y: 712,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "102",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 904,
      y: 736,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "103",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 455,
      y: 733,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "104",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 603,
      y: 730,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "105",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 696,
      y: 792,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "74",
      data: ""
    },
    {
      id: "111",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1869,
      y: 56,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "112",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2001,
      y: 62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "113",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2116,
      y: 72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "114",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2275,
      y: 58,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "115",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2413,
      y: 51,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "116",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2532,
      y: 72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "117",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1778,
      y: 116,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "118",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1903,
      y: 122,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "119",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2000,
      y: 152,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "120",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2166,
      y: 146,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "121",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2320,
      y: 129,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "122",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2447,
      y: 124,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "123",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2593,
      y: 131,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "124",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1806,
      y: 192,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "125",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1894,
      y: 229,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "126",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2082,
      y: 204,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "127",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2226,
      y: 196,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "128",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2366,
      y: 193,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "129",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2502,
      y: 204,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "130",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2625,
      y: 204,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "131",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1791,
      y: 309,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "132",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2292,
      y: 258,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "133",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2421,
      y: 267,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "134",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2524,
      y: 286,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "135",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2343,
      y: 342,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "136",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1423,
      y: 592,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "137",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1531,
      y: 665,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "138",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1662,
      y: 651,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "139",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1787,
      y: 670,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "140",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1900,
      y: 633,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "141",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2015,
      y: 590,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "142",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2101,
      y: 538,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "143",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1397,
      y: 705,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "144",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1978,
      y: 715,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "145",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2086,
      y: 675,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "146",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2188,
      y: 628,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "147",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1374,
      y: 812,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "148",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1505,
      y: 803,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "149",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1626,
      y: 765,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "150",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1747,
      y: 750,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "151",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1877,
      y: 772,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "152",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1943,
      y: 833,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "153",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2077,
      y: 828,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "154",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2186,
      y: 798,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "155",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2276,
      y: 720,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "156",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2584,
      y: 634,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "157",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2450,
      y: 725,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "158",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2548,
      y: 752,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "159",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2656,
      y: 773,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_4",
      parent: "110",
      data: ""
    },
    {
      id: "165",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3217,
      y: 47,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "166",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3048,
      y: 75,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "167",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2908,
      y: 131,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "168",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3327,
      y: 125,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "169",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3150,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "170",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3007,
      y: 211,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "171",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3255,
      y: 235,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "172",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3110,
      y: 278,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "173",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2875,
      y: 583,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "174",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3190,
      y: 540,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "175",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3057,
      y: 606,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "176",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3312,
      y: 596,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "177",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2947,
      y: 687,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "178",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3169,
      y: 703,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "179",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3378,
      y: 718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "180",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3542,
      y: 694,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "164",
      data: ""
    },
    {
      id: "186",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4148,
      y: 216,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "187",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4218,
      y: 112,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "188",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4320,
      y: 198,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "189",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4430,
      y: 84,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "190",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4465,
      y: 246,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "191",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4561,
      y: 151,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "192",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4685,
      y: 66,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "193",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4626,
      y: 252,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "194",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4736,
      y: 179,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "195",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4848,
      y: 78,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "196",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5113,
      y: 79,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "197",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5171,
      y: 172,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "198",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5312,
      y: 130,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "199",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4870,
      y: 228,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "200",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4745,
      y: 317,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "201",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5038,
      y: 533,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "202",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4930,
      y: 632,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "203",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4718,
      y: 616,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "204",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5062,
      y: 734,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "205",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5168,
      y: 628,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "206",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5325,
      y: 585,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "207",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5299,
      y: 740,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "208",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5202,
      y: 481,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "209",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4822,
      y: 726,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "red_plum_4",
      parent: "185",
      data: ""
    },
    {
      id: "249",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5594,
      y: 46,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "250",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5526,
      y: 90,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "251",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5465,
      y: 136,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "252",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5648,
      y: 106,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "253",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5567,
      y: 166,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "0494cb2e-f425-4744-b1bb-0ce534eb9a39",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5488,
      y: 228,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "254",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5606,
      y: 240,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "255",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5522,
      y: 305,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "256",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5941,
      y: 503,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "257",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6094,
      y: 531,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "258",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6018,
      y: 565,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "259",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6093,
      y: 632,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "260",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5854,
      y: 529,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "261",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5931,
      y: 598,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "262",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6000,
      y: 665,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "263",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6064,
      y: 736,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "265",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5825,
      y: 604,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "266",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5903,
      y: 674,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "267",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5974,
      y: 746,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "268",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5710,
      y: 595,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "269",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5644,
      y: 637,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "270",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5778,
      y: 668,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "271",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5851,
      y: 732,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "272",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5917,
      y: 813,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "273",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5791,
      y: 793,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "274",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5710,
      y: 701,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "275",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5550,
      y: 650,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "276",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5616,
      y: 712,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "277",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5517,
      y: 717,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "278",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5579,
      y: 789,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "279",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5680,
      y: 792,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "280",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6473,
      y: 79,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "281",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6561,
      y: 146,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "282",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6647,
      y: 212,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "283",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6536,
      y: 221,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "284",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6438,
      y: 151,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "285",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6355,
      y: 195,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "286",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6205,
      y: 289,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "287",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6310,
      y: 263,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "288",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6537,
      y: 323,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "289",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6442,
      y: 258,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "290",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6392,
      y: 322,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "291",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6357,
      y: 408,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "292",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6453,
      y: 383,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "293",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6527,
      y: 424,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "294",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6280,
      y: 348,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "295",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6645,
      y: 306,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "214",
      data: ""
    },
    {
      id: "ebf141fc-1d61-4e17-b1bc-00b7948fc1c0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6788,
      y: 600,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "5cd4972e-d9e8-495f-810d-627c2adde436",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6870,
      y: 544,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "f083c824-805f-42ca-be91-9e831557b4b7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6958,
      y: 490,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "fd5c916c-243c-4991-a321-3141e46f4914",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7115,
      y: 458,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "4e37f9bd-b74a-468d-a4fe-afe3290e1778",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7035,
      y: 504,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "5c69b876-797a-40ab-aa7b-82c15b87466f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6972,
      y: 555,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "d732aedb-888c-429e-b741-6624aca3f3d6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6866,
      y: 620,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "e1b9c477-38cf-488d-af26-8430a41f880e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6864,
      y: 702,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "b2bcd231-f019-4dec-8bb8-630fe9e605f6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6952,
      y: 754,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "8cab1f53-4ceb-445a-b26e-5d5c59fd1989",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7051,
      y: 595,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "fbcd3d87-bd46-43ff-b56c-acff2a66b0b5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7305,
      y: 610,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "9f8ca060-f8a0-45ab-abe7-c5ca70f66feb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7121,
      y: 537,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "240fb334-4137-48ab-bebb-0c697dda37ca",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7395,
      y: 649,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "050e85be-1a17-4faa-b65c-73b8cbe93bde",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7165,
      y: 609,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "d29121e9-4298-46d3-b01a-501d92a2fd02",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7241,
      y: 534,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "f5bd9be3-a4c7-4996-bce9-8f46107c3746",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6959,
      y: 648,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "fc48b5ad-7dd3-4734-b57e-f3846a0205d6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7315,
      y: 702,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "0a055a73-d3cd-4a1a-a8e8-2d6805cea15f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7233,
      y: 660,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "d45e315a-9102-490b-8612-67a23fc06c08",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7060,
      y: 678,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "6e4193c6-a488-45d4-b4e9-dd1e0aa3777d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7238,
      y: 753,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "f12eb7d8-b68f-43fe-8372-734db7242f60",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7151,
      y: 718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "3bdaca26-9936-40c3-915e-326a194e4b87",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7075,
      y: 799,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "3bd4ba4a-dd91-4d97-926c-b02d293a6791",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7376,
      y: 756,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "842e8ce9-7898-4667-8409-32ebfe1f1fc8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7791,
      y: 49,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "54d99c60-1834-49fb-a804-be2cff2f3cb6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7706,
      y: 115,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "0f4a5020-b034-4111-a31f-c726edaf329e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7942,
      y: 48,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "6af24022-17f2-4674-8c95-78afb31a1d2d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7850,
      y: 114,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "637dfbec-69f5-4f1a-b1da-fe815006545a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7763,
      y: 188,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "efcd3494-5231-49e2-9ce7-fb78d7d8f441",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8025,
      y: 85,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "8e698cc5-2b74-456d-bbff-cae67533efab",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7920,
      y: 159,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "9ad1a5ca-7ddd-4c77-8a04-1f3681335f5f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7828,
      y: 246,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "089e494d-fc42-4aa5-9357-2e55e6462c53",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7981,
      y: 216,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "1ccd7e0a-df89-472e-b758-2739b5f0538a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7905,
      y: 278,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_4",
      parent: "219",
      data: ""
    },
    {
      id: "74d89050-710b-44b8-8780-fcc3ee209c9a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8111,
      y: 571,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "28fc75eb-fb2a-4997-83a8-7fcbcf216cc6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8291,
      y: 562,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "3a54ae06-b60d-44a7-907a-e625dac7649a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8205,
      y: 713,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "da482cd4-04de-44a4-aefd-a34f4dd95086",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8381,
      y: 670,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "91675776-dd5b-47ca-a629-2cdd87416bb9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8487,
      y: 767,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "e1e17864-51d6-494d-b3f2-68764deefaed",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8181,
      y: 445,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "37656a3a-659d-43b5-92da-443cdd29e0a5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8476,
      y: 241,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "79b941f5-ec03-4ad8-85b9-f437f6667a1b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8602,
      y: 323,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "96385e8d-958c-4341-8ef3-7f3aa8837825",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8688,
      y: 418,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "9920c8e5-dc26-43ae-8ee1-04b5d46becf5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8564,
      y: 147,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "464f8fa3-ff05-45e5-b52f-06b510b4684d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8918,
      y: 262,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "e657c880-b4ec-4e76-9afc-eae6a51b59d7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8969,
      y: 133,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "115e8eeb-4155-44f4-9049-3a6fd83167d9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9076,
      y: 202,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "59e85df8-7486-4857-8f28-224dfb0c123b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9144,
      y: 72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "c3a5adc9-35b4-4c9e-aa29-1a24831431b1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9041,
      y: 630,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "d18bd12f-ffb0-49a6-bfb8-f0c4b5b104e9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8955,
      y: 767,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "bcf5e296-8a92-4936-a6ff-e9222171e2ad",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9161,
      y: 721,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "f2a4f863-f9c2-490e-bbc0-8aba738411e2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9271,
      y: 621,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "5984c19c-758a-4861-a93b-22cf66778f72",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9377,
      y: 518,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "6349d6bf-20d5-41ee-adef-424b5040490a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9471,
      y: 621,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "ec947b96-8834-4179-b87d-7f3c98e9a6af",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9344,
      y: 760,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "7644df0b-f3c7-4bfd-ae89-f64d3bb0a19a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9576,
      y: 728,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "0114ba71-022a-4835-af15-de8777143b7a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8710,
      y: 82,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "3b73fa56-c813-4c9f-b3bf-2518cd45ed80",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8756,
      y: 240,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "224",
      data: ""
    },
    {
      id: "20632d38-379f-403a-83f3-678b590243da",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9789,
      y: 68,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "19436729-7e1b-4780-9eae-003a0c9ff1b0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9611,
      y: 56,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "1b969655-92af-4981-b051-7185904fa695",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9699,
      y: 170,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "11f8bab3-d20e-4a7d-8be0-8eeafa58890d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9517,
      y: 157,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "b1665dbb-a2f2-4a2e-bcc3-dac6b7fbe5e0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9889,
      y: 168,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "042419c7-5d6b-43b3-8840-53fcfdee5ea5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9621,
      y: 272,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "97c909d7-85ff-4153-bf73-18012199203d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9808,
      y: 256,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "447bbb93-e7be-43fa-9b40-dfc92533f393",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9965,
      y: 304,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "9a0680a6-dfc8-4c77-b8a9-2d8063404c5b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9721,
      y: 397,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "aa1499db-6033-4884-8db7-cc366fe71180",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9884,
      y: 442,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "701dc46b-e49c-4055-b79e-43b8d9a1e3de",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10151,
      y: 575,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "7b75ac6b-32c9-4457-81a4-4213732f4b1c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10320,
      y: 622,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "52612631-e9d2-4753-bede-30d3de9ad5eb",
      type: "Sprite",
      name: "the_littlest_tree_in_sofa",
      nameSpace: "",
      className: "",
      x: 9705,
      y: 676,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "df5c9a8c-d4e5-4205-bc37-1373990bc131",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10045,
      y: 677,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "b47fe3e9-f328-4a53-abac-0f3bf27ff8ef",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10172,
      y: 744,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "dfe2f887-13e5-4ddf-86b9-58bf25034f85",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9893,
      y: 744,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "da99deda-b0e3-4101-896d-846bcfac2a60",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10380,
      y: 755,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "4a1caae4-1e8e-4c80-9d02-239571e28654",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10546,
      y: 725,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_4",
      parent: "229",
      data: ""
    },
    {
      id: "107",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1183,
      y: 270,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "106",
      data: ""
    },
    {
      id: "161",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2061,
      y: 528,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "160",
      data: ""
    },
    {
      id: "182",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3107,
      y: 203,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "181",
      data: ""
    },
    {
      id: "211",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4923,
      y: 548,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "210",
      data: ""
    },
    {
      id: "216",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5909,
      y: 603,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "215",
      data: ""
    },
    {
      id: "221",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7074,
      y: 566,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "220",
      data: ""
    },
    {
      id: "226",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8684,
      y: 338,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "225",
      data: ""
    },
    {
      id: "231",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9715,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "230",
      data: ""
    },
    {
      id: "108",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "107",
      data: ""
    },
    {
      id: "109",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_harvest_map",
      parent: "107",
      data: ""
    },
    {
      id: "162",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "161",
      data: ""
    },
    {
      id: "163",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ginger_harvest_map",
      parent: "161",
      data: ""
    },
    {
      id: "183",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "182",
      data: ""
    },
    {
      id: "184",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "redplum_harvest_map",
      parent: "182",
      data: ""
    },
    {
      id: "212",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "211",
      data: ""
    },
    {
      id: "213",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "redplum_harvest_map",
      parent: "211",
      data: ""
    },
    {
      id: "217",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "216",
      data: ""
    },
    {
      id: "218",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_harvest_map",
      parent: "216",
      data: ""
    },
    {
      id: "222",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "221",
      data: ""
    },
    {
      id: "223",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wasabi_harvest_map",
      parent: "221",
      data: ""
    },
    {
      id: "227",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "226",
      data: ""
    },
    {
      id: "228",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_harvest_map",
      parent: "226",
      data: ""
    },
    {
      id: "232",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "231",
      data: ""
    },
    {
      id: "233",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "persimmon_harvest_map",
      parent: "231",
      data: ""
    }
  ]
} as const;

export class WorldLayout16 {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  backgrounds: GameObject<PIXI.Container>;
  nodesContainer: GameObject<PIXI.Container>;
  the_littlest_tree_in_sofa: GameObject<PIXI.Sprite>;
  cropsSectorA: (GameObject<PIXI.Container>)[];
  cropsSectorB: (GameObject<PIXI.Container>)[];
  signsSectorA: (GameObject<PIXI.Container>)[];
  signsSectorB: (GameObject<PIXI.Container>)[];

  constructor() {
    populate(this, raw);
  }
}
